

let BASE_URL
let BASE_DOC_URL

if (process.env.NODE_ENV === 'production') {
	BASE_URL = window.location.host == 'xn--80aksgi6f.xn--80aaaf3bi1ahsd.xn--80asehdb'
		? process.env.VUE_APP_URL
		: process.env.VUE_APP_URL_ADMIN
	BASE_DOC_URL = window.location.host == 'xn--80aksgi6f.xn--80aaaf3bi1ahsd.xn--80asehdb'
		? process.env.VUE_APP_DOC_URL
		: process.env.VUE_APP_DOC_URL_ADMIN
} else {
	BASE_URL = window.location.host == 'org-admin.kvp.local'
		? process.env.VUE_APP_URL
		: process.env.VUE_APP_URL_ADMIN
	BASE_DOC_URL = window.location.host == 'org-admin.kvp.local'
		? process.env.VUE_APP_DOC_URL
		: process.env.VUE_APP_DOC_URL_ADMIN
}

export { BASE_URL, BASE_DOC_URL }

//ВНИМАНИЕ!!!!
//  панелька работает на 2-х разных доменах: https://org-admin.jfservice.ru  "панель.квартплата.онлайн"...
// если адрес в браузере https://org-admin.jfservice.ru то отправляем запросы на VUE_APP_URL_ADMIN, если другой то https://квартплата.онлайн/orgadmin  (VUE_APP_URL)